const SET_LIST = (state, payload) => {
  state.list = payload
}

const SET_CURRENT = (state, payload) => {
  state.current = payload
}

const SET_ERRORS = (state, payload) => {
  state.errors = { ...payload }
}

const SET_PAYER = (state, payload) => {
  Object.assign(state.payer, payload)
}

const RESET_PAYER = (state) => {
  state.payer = JSON.parse(JSON.stringify(state.initialPayer))
}

const RESET_ERRORS = (state) => {
  state.errors = { ...state.initialErrors }
}

const UPDATE_VALUES = (state, payload) => {
  Object.assign(state.payer, payload)
}

const SET_LIST_TO_CAMPAIGN = (state, payload) => {
  state.listToCampaign = payload
}

export default {
  SET_LIST,
  SET_CURRENT,
  SET_ERRORS,
  SET_PAYER,
  RESET_PAYER,
  RESET_ERRORS,
  UPDATE_VALUES,
  SET_LIST_TO_CAMPAIGN
}



// WEBPACK FOOTER //
// ./src/features/payers/store/mutations.js